/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

/**
 * Model `CommentTypeModel`.
 */
@endpoint('deliverySurveyComment/type')
export default class CommentTypeModel extends BaseModel {
  /**
   * Properties.
   */
  code: string;

  level: string;

  name: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<CommentTypeModel>) {
    super(data);
  }
}
